export type Bonus = {
  number: string
  title: string
  /** Short title printed on the code-drawn cover. */
  short: string
  body: string
  accent: string
  /** Optional rendered cover. When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 12-Week No-Lines Season Map',
    short: 'Season Map',
    body: 'Your whole season, already sequenced. Pick your age group and how many practices you run per week, and the map tells you exactly which practice to run at every session for 12 weeks — from first day to last game. Includes an 8-week short-season version and a tracking sheet.',
    accent: 'bg-gold',
    cover: 'https://cdn.magicpatterns.com/uploads/ioS31MQ8hJHKmEg37H6qB4/lc-bonus-1.png',
  },
  {
    number: '02',
    title: 'The Practice Finder: Fix the Problem You See',
    short: 'Practice Finder',
    body: 'Kids bunching up? Dropping every catch? Chasing the ball on defense? 40 common field problems in plain coach language, each pointing to the practice that fixes it and a one-line cue to use right now.',
    accent: 'bg-turf',
    cover: 'https://cdn.magicpatterns.com/uploads/33yThZZkaeqREty52DaJyu/lc-bonus-2.png',
  },
  {
    number: '03',
    title: 'Never Played? The Lacrosse Primer for New Coaches',
    short: 'Lacrosse Primer',
    body: 'Understand the game in one evening: the field, the positions, a visual glossary of 60 terms, and how field boys, field girls and box differ — in plain English, with diagrams.',
    accent: 'bg-sky',
    cover: 'https://cdn.magicpatterns.com/uploads/uEjeHbUFxoct6cAosVXo1V/lc-bonus-3.png',
  },
  {
    number: '04',
    title: 'Two-Sentence Coach Talk Cards',
    short: 'Coach Talk Cards',
    body: 'What to say, word for word, to get kids’ attention, explain a game in two sentences and restart fast. 12 call-and-response attention getters, 20 two-sentence explanations, 30 specific praise lines. Pocket format.',
    accent: 'bg-gold',
    cover: 'https://cdn.magicpatterns.com/uploads/pu2kLX9ifcpiGaKNzRRs54/lc-bonus-4.png',
  },
  {
    number: '05',
    title: 'The One-Bag Field Setup Kit',
    short: 'Field Setup Kit',
    body: 'One bag, one checklist, five field layouts. Know exactly what to pack and how to set up pods, stations and small-sided fields — in paces and meters — before the first kid arrives.',
    accent: 'bg-turf',
    cover: 'https://cdn.magicpatterns.com/uploads/c2XMtGAG5t2Kedv7qNuxUS/lc-bonus-5.png',
  },
]
